<template>
  <div class="patient-create-study-id">
    <v-form
      v-on:submit.prevent
      class="patient-form"
    >
      <v-simple-table class="patient-form__table">
        <template v-slot:default>
          <tbody>
            <tr>
              <td>{{ $ucfirst($t('pdf.medicationPrescription.subjectId', {catalog: 'messages'})) }}</td>
              <td style="width: unset">
                <v-text-field
                  v-model="studyId"
                  outlined
                  dense
                  :errorMessages="errorMessage"
                  @blur="validate"
                ></v-text-field>
              </td>
              <td>
                <v-btn
                  large
                  class="patient-form__btn"
                  color="primary"
                  text
                  @click="retrieveData"
                >
                  <eva-icon
                    class="patient-create__icon mr-2"
                    name="flip-2-outline"
                  />
                  {{ $ucfirst($t('patient.retrieveDataFromEDC')) }}
                </v-btn>
              </td>
            </tr>
            <tr>
              <td>{{ $ucfirst($t('patient.gender')) }}</td>
              <td colspan="2">
                <v-radio-group
                  :value="gender"
                  disabled
                  row
                >
                  <v-radio
                    :label="$ucfirst($t('male'))"
                    value="male"
                  ></v-radio>
                  <v-radio
                    :label="$ucfirst($t('female'))"
                    value="female"
                  ></v-radio>
                </v-radio-group>
              </td>
            </tr>
            <tr>
              <td>{{ $ucfirst($t('patient.yearofbirth')) }}</td>
              <td colspan="2">
                <v-text-field
                  :value="birthYear"
                  disabled
                  outlined
                  dense
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>{{ $ucfirst($t('patient.startdate')) }}</td>
              <td colspan="2">
                <v-text-field
                  :value="startDate"
                  disabled
                  outlined
                  dense
                ></v-text-field>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

/**
 * Component PatientCreateStudyId.vue
 *
 * @module PatientCreateStudyId
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.2] app/src/APP_DASHBOARD/templates/views/Patient/Create/PatientCreateStudyId.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'PatientCreateStudyId',
  data() {
    return {
      errorMessage: '',
    }
  },
  computed: {
    ...mapGetters({
      gender: 'newPatient/gender',
      birthYear: 'newPatient/birthYear',
      startDate: 'newPatient/startDate',
    }),
    studyId: {
      get() {
        return this.$store.getters['newPatient/subjectId'];
      },
      set(studyId) {
        studyId = studyId.trim();
        this.$store.dispatch('newPatient/setSubjectId', studyId);
      },
    },
  },
  methods: {
    async retrieveData() {
      if (!this.studyId) {
        this.validate();
        return;
      }
      try {
        await this.$store.dispatch('newPatient/getData');
      } catch (error) {
        this.$toasted.show(error.message, {
          type : 'error',
          icon : 'error_outline',
          position: 'bottom-center',
        });
      }
    },
    validate() {
      if (!this.studyId) {
        this.errorMessage = this.$t('validation.IS_REQUIRED');
      } else {
        this.errorMessage = ''
      }
    }
  },
};
</script>
